<template>
  <article
    :class="{
      'pricing-tariffs-feature': true,
      'pricing-tariffs-feature--professional': tariff === 'professional',
      'pricing-tariffs-feature--maximum': tariff === 'maximum',
      'pricing-tariffs-feature--enterprise': tariff === 'enterprise',
    }"
  >
    <div class="pricing-tariffs-feature__content">
      <h2 v-html="feature" class="pricing-tariffs-feature__title"></h2>
      <button
        v-if="!mediaLgMatches"
        v-html="translations.slider.action"
        :class="{
          'pricing-tariffs-feature__button': true,
          'pricing-tariffs-feature__button--enterprise': tariff === 'enterprise',
        }"
        :data-modal="'#demoRequestModal'"
      />
    </div>
    <picture>
      <template v-if="mdSkip">
        <source
          type="image/webp"
          :media="`(min-width: ${breakpoints.mdMin})`"
          :srcset="`${imgSrc}/lg/${index}.webp, ${imgSrc}/lg/${index}@2x.webp 2x`"
        />
      </template>
      <template v-else>
        <source
          type="image/webp"
          :media="`(min-width: ${breakpoints.lgMin})`"
          :srcset="`${imgSrc}/lg/${index}.webp, ${imgSrc}/lg/${index}@2x.webp 2x`"
        />
        <source
          type="image/webp"
          :media="`(min-width: ${breakpoints.mdMin})`"
          :srcset="`${imgSrc}/md/${index}.webp, ${imgSrc}/md/${index}@2x.webp 2x`"
        />
      </template>
      <source type="image/webp" :srcset="`${imgSrc}/sm/${index}.webp, ${imgSrc}/sm/${index}@2x.webp 2x`" />
      <img :src="`${imgSrc}/lg/${index}@2x.png`" :alt="`${translations.slider.img} ${index}`" />
    </picture>
  </article>
</template>

<script>
import { BREAKPOINTS } from '~scripts/core/breakpoints';
import translations from '~scripts/pages/price/index/vue/PricingTariffsFeatures/pricing-translations';

export default {
  name: 'PricingTariffsFeature',
  props: {
    mdSkip: {
      type: Boolean,
      default: false,
    },
    tariff: {
      type: String,
      required: true,
    },
    feature: {
      type: String,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      mediaLgMatches: false,
    };
  },
  computed: {
    region() {
      return window.region;
    },
    lang() {
      return this.region === 'ai' ? 'en' : 'ru';
    },
    breakpoints() {
      return BREAKPOINTS;
    },
    mediaLg() {
      return window.matchMedia(`(min-width: ${this.breakpoints.lgMin})`);
    },
    translations() {
      return translations[this.lang];
    },
    imgSrc() {
      if (this.tariff === 'enterprise') {
        return `/static/promo-static/landing-2021/src/images/pages/price/index/pricing-tariffs-features/${this.tariff}`;
      } else {
        return `/static/promo-static/landing-2021/src/images/pages/price/index/pricing-tariffs-features/${this.tariff}/${this.region}`;
      }
    },
  },
  mounted() {
    this.isMediaLg();
    this.mediaLg.addEventListener('change', this.isMediaLg, { passive: true });
  },
  beforeDestroy() {
    this.mediaLg.removeEventListener('change', this.isMediaLg);
  },
  methods: {
    isMediaLg() {
      this.mediaLgMatches = this.mediaLg.matches;
    },
  },
};
</script>
